import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

const BuyActivityPaneBody = ({ children }) => {
  return (
    <Box color="black" borderColor="gray">
      {children}
    </Box>
  );
};

export default BuyActivityPaneBody;

BuyActivityPaneBody.propTypes = {
  children: PropTypes.node,
};
